module.exports = __webpack_public_path__ + "img/wee_logo.f736ad91.png";